import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
    values: {
      excel: 'mdi-microsoft-excel',
      csv: 'mdi-file-delimited-outline'
    }
  },

  // iconfont: 'md',
  theme: {
    themes: {
      light: {
        primary: colors.deepOrange.lighten1,
        accent: colors.deepOrange.lighten2,
        oderon: '#f7931e',
        warning: '#FFFFCC'
      }
    }
  }
})
